module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "color": "deep-orange darken-2",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.user.fullname) + " " + _vm._s(_vm.activeItem ? ' - ' + _vm.activeItem.name : ''))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [_c('v-navigation-drawer', {
    staticClass: "left-element deep-orange lighten-5",
    attrs: {
      "mini-variant": "",
      "ini-variant-width": "100",
      "permanent": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      staticClass: "yellow--text",
      attrs: {
        "value": _vm.activeItem,
        "to": _vm.baseRoute + item.path,
        "active-class": "red--text"
      },
      on: {
        "click": function($event) {
          _vm.activeItem = item
        }
      }
    }, [_c('v-list-tile-action', [_c('v-badge', {
      attrs: {
        "right": "",
        "color": "brown"
      }
    }, [(item.path === 'messages' && _vm.unreadMessageCount > 0) ? _c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(_vm.unreadMessageCount))]) : _vm._e(), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(item.icon))])], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('router-view', {
    staticClass: "right-element"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c4ef2d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/coaching/CoachedUserWorkspace.vue
// module id = 1206
// module chunks = 1